import { CareerRecommendInfo, TrnCareerRecommendUpdateForm } from '@/types';
import {
  updateRecommend,
  getCareerInfo,
  updateCareerSettingFlag,
  updateCareerInfoForResume,
  selectZipCode,
  getMstUserInfo,
  getCareerInfoForRecommend,
  getCareerInfoForConditionSearch,
  updateCareerBasicInfo,
} from '../trnCareerEndpoint';
import { CareerConditionSearchInfoDetail, CareerInfo, CareerSettingForm, MstUserBasicInfo, TrnCareerBasicInfoUpdateForm, TrnCareerResumeUpdateForm, UpdateSettingResponse } from '@/types/career';
import { CareerResumeInfoDetail } from '@/types/career';
import { getCareerInfoForResume } from '../trnCareerEndpoint';
import { fetchSchlName } from '../trnOrderEndpoint';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import store from '@/store';
const recommendConst = MYPAGE_CONSTANTS.RECOMMEND;
export const updateCareerRecommendService = async (careerInfo: TrnCareerRecommendUpdateForm) => {
  return await updateRecommend(careerInfo);
};

export const getCareerInfoRecommendService = async () => {
  let careerInfo: CareerRecommendInfo = {} as CareerRecommendInfo;
  const careerInfoResp = await getCareerInfoForRecommend();
  if (careerInfoResp.data.detail != null) {
    careerInfo = careerInfoResp.data.detail;
  }
  return careerInfo;
};

export const getCareerInfoResumeService = async () => {
  let careerInfo: CareerResumeInfoDetail = {} as CareerResumeInfoDetail;
  const careerInfoResp = await getCareerInfoForResume();
  if (careerInfoResp.data.detail != null) {
    careerInfo = careerInfoResp.data.detail;
  }
  return careerInfo;
};

export const getCareerInfoConditionSearchService = async () => {
  let careerInfo: CareerConditionSearchInfoDetail = {} as CareerConditionSearchInfoDetail;
  const careerInfoResp = await getCareerInfoForConditionSearch();
  if (careerInfoResp.data.detail != null) {
    careerInfo = careerInfoResp.data.detail;
  }
  return careerInfo;
};

/**
 * Updates career setting flags via API.
 * Returns response data if available; otherwise returns an array with a 500 error response.
 *
 * @param params CareerSettingForm - The API request parameters
 * @returns Promise<UpdateSettingResponse[]> - Array of response objects
 */
export const updateCareerSettingFlagService = async (params: CareerSettingForm): Promise<UpdateSettingResponse[]> => {
  try {
    const response = await updateCareerSettingFlag(params);

    // If response.data is missing, return error 500
    if (!response?.data) {
      return [
        {
          responseFault: {
            responseId: '500',
            responseMessage: 'Unknown error',
            responseType: '',
          },
        },
      ];
    }

    // Return response data (assumed to be UpdateSettingResponse[])
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status || error?.status;
    return [
      {
        responseFault: {
          responseId: String(status || 500),
          responseMessage: 'Unknown error',
          responseType: '',
        },
      },
    ];
  }
};

export const updateCareerResumeService = async (formData: TrnCareerResumeUpdateForm) => {
  return await updateCareerInfoForResume(formData);
};
export const updateCareerBasicInfoService = async (formData: TrnCareerBasicInfoUpdateForm) => {
  return await updateCareerBasicInfo(formData);
};

export const fetchSchlNameByIdService = async (id: number) => {
  const res = await fetchSchlName(id);
  if (res.data && res.data.detail) {
    return res.data.detail;
  }
  return '';
};

export const getZipCodeService = async (zipCode: string) => {
  const param = {
    zipCode: zipCode,
  };
  const res = await selectZipCode(param);
  if (res.data && res.data.detail) {
    return res.data.detail;
  }
  return '';
};

export const getMstUserInfoService = async () => {
  const res = await getMstUserInfo();
  if (res.data && res.data.detail) {
    return res.data.detail as MstUserBasicInfo;
  }
  return {} as MstUserBasicInfo;
};

export const getCareerInfoService = async () => {
  let careerInfo: CareerInfo = {} as CareerInfo;
  const careerInfoResp = await getCareerInfo();
  if (careerInfoResp.data.detail != null && careerInfoResp.data.detail?.length > 0) {
    careerInfo = careerInfoResp.data.detail[0];
  }
  return careerInfo;
};

export const isShowWarningRecommendService = async (careerInfo: CareerRecommendInfo) => {
  if(!(careerInfo.wishWkAreaAllFlg))
  {
    let wishWkAreaIds: number[] = [];  
    if(careerInfo.wishWkAreaId)
    {
      const ids = String(careerInfo.wishWkAreaId);
      wishWkAreaIds = ids.split('/').map(Number).filter(i => i);
    }
    if(wishWkAreaIds.length == 0)
    {
      return true;
    }
  }
  if(!(careerInfo.wishOcupCtgNotParticalarFlg))
  {
    let isExistOcupt = false;
    for(let i= 1; i <= recommendConst.MAX_WISH_OCCUP; i++)
    {
      if((careerInfo as any)[`wishOcupCtg${i}Id`])
      {
        isExistOcupt = true;        
        break;
      }
    }
    if(!isExistOcupt)
    {
      return true;
    }
  }

  if(careerInfo.minWishAnnualIncomeNum == null || careerInfo.minWishAnnualIncomeNum == undefined || !careerInfo.changeJobReason || !careerInfo.changeJobPriority)
  {
    return true;
  }
  return false;
};